var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 41 73"}},[_c('polygon',{staticClass:"cls-1",attrs:{"points":"4.27 71.45 0.73 67.92 32.56 36.09 0.73 4.27 4.27 0.73 39.63 36.09 4.27 71.45"}})])}
var staticRenderFns = []

export { render, staticRenderFns }